module.exports = __webpack_public_path__ + "assets1783936157458/img/yanshi-select.23ae8cd0.svg";